<mat-card>
  <mat-card-content class="info-container">
    <span class="info-value">{{ value }}</span>
    <span class="info-label">{{ label }}</span>
  </mat-card-content>
</mat-card>